var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCashouticon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_32_1",
    "data-name": "Component 32 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.273,
    height: 57.894,
    viewBox: "0 0 54.273 57.894",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_856",
    "data-name": "Group 856"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1018",
    "data-name": "Path 1018",
    d: "M188.193,238.322a4.639,4.639,0,0,1-1.819,3.912,14.736,14.736,0,0,1-4.56,2.556c-4.566,1.71-9.33,2.211-14.725,2.3-1.039-.062-2.643-.113-4.24-.259a34.977,34.977,0,0,1-9.718-2.159,14.413,14.413,0,0,1-4.261-2.441,4.653,4.653,0,0,1-1.816-3.915c.067-1.3.063-2.612,0-3.914a4.56,4.56,0,0,1,1.725-3.761,14.549,14.549,0,0,1,4.713-2.667,36.39,36.39,0,0,1,10.319-2.1,45.163,45.163,0,0,1,16.433,1.58,16.456,16.456,0,0,1,6.178,3.142,4.592,4.592,0,0,1,1.771,3.869A36.659,36.659,0,0,0,188.193,238.322Z",
    transform: "translate(-147.047 -225.736)",
    fill: "#ea6a5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1019",
    "data-name": "Path 1019",
    d: "M172.813,267.655a16.125,16.125,0,0,1-6.107-3.143,4.573,4.573,0,0,1-1.742-3.817c.066-1.3.012-2.611.015-3.915,0-.181.022-.36.036-.576.772.452,1.468.908,2.2,1.282,4.768,2.425,9.908,3.3,15.174,3.64a4.822,4.822,0,0,0-.266,1.58,5.279,5.279,0,0,0,1.958,4l3,2.669A43.4,43.4,0,0,1,172.813,267.655Z",
    transform: "translate(-164.958 -223.843)",
    fill: "#ea6a5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1020",
    "data-name": "Path 1020",
    d: "M153.408,269.481v-1.69c.81.475,1.506.931,2.242,1.3,4.86,2.466,10.1,3.337,15.47,3.656a51.134,51.134,0,0,0,8.725-.245l1.224,1.088,2.837,2.524c.157.139.313.28.469.42.476.428.967.87,1.505,1.315a5.612,5.612,0,0,0,1.927,1.025,36.854,36.854,0,0,1-10.134,2,45.018,45.018,0,0,1-16.49-1.637,16.034,16.034,0,0,1-6.047-3.121,4.528,4.528,0,0,1-1.739-3.817C153.456,271.367,153.408,270.422,153.408,269.481Z",
    transform: "translate(-153.388 -223.124)",
    fill: "#ea6a5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1021",
    "data-name": "Path 1021",
    d: "M147.254,273.437c-.013.043-.025.085-.039.127v-.142Z",
    transform: "translate(-106.279 -222.774)",
    fill: "#ea6a5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1022",
    "data-name": "Path 1022",
    d: "M150.022,250.842a5.086,5.086,0,0,0-2.963-4.119,25.115,25.115,0,0,0,3.2-1.8c0,1.551-.018,3,.006,4.446A3.939,3.939,0,0,1,150.022,250.842Z",
    transform: "translate(-109.128 -224.544)",
    fill: "#ea6a5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1023",
    "data-name": "Path 1023",
    d: "M159.32,253.588c-1.238-.86-2.4-1.885-2.551-3.453-.166-1.688-.038-3.4-.038-5.164a2.209,2.209,0,0,1,.26.124,25.786,25.786,0,0,0,8.891,3.648,50.911,50.911,0,0,0,17.392.911c1.459-.169,2.9-.387,4.326-.677-2.051,1.81-4.107,3.632-6.108,5.407l-1.643,1.456-.8.709q-.693.615-1.388,1.229a45.62,45.62,0,0,1-10.672-1.1A21.442,21.442,0,0,1,159.32,253.588Z",
    transform: "translate(-156.682 -224.541)",
    fill: "#ea6a5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1024",
    "data-name": "Path 1024",
    d: "M145.2,272.569l-3.849-3.423q-3.127-2.782-6.255-5.562c-.534-.475-.533-.573.019-1.06.387-.341.771-.684,1.157-1.025q1.431-1.265,2.858-2.531l2.487-2.2q3.389-3,6.784-6a.725.725,0,0,1,.438-.149.434.434,0,0,1,.133.018c.113.038.2.321.2.495.014,1.035,0,2.071,0,3.106v.279c0,.7,0,1.4,0,2.125.133.012.214.021.293.025a15.755,15.755,0,0,1,3.38.566q.594.166,1.173.378a16.585,16.585,0,0,1,3,1.455,19.594,19.594,0,0,1,7.886,9.662,34.042,34.042,0,0,1,2.259,12.88c0,.239-.047.436-.321.474a.607.607,0,0,1-.072.005c-.264,0-.34-.222-.409-.441a16.676,16.676,0,0,0-6.071-8.419A19.068,19.068,0,0,0,154,270.007q-.679-.194-1.382-.329a16.306,16.306,0,0,0-1.647-.237c-.219-.02-.439-.025-.66-.025-.38,0-.764.018-1.156.018v.492q0,.7.006,1.4c.006,1.215.012,2.429,0,3.643,0,.2-.1.529-.219.561a.41.41,0,0,1-.1.012.914.914,0,0,1-.522-.2c-.632-.521-1.234-1.08-1.847-1.625Z",
    transform: "translate(-112.879 -224.19)",
    fill: "#ea6a5e"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashouticon);
export default __webpack_public_path__ + "lbHeaderFiles/static/media/cash.out.icon.9b48f2b2cb199953a1dc60460213c338.svg";
export { ForwardRef as ReactComponent };